export enum StatusInPortsType {
  INTRODUCED = 1,
  PRE_APPROVED = 2,
  TO_BE_APPROVED = 3,
  APPROVED = 4,
  REJECTED = 5,
  CANCELLED = 6,
  LETTED_IN = 7,
}
